export default __webpack_public_path__ + "39b7400f88e97f917ec8c16464406aa8.png";